export class CateringAPI {
  static readonly GET_ALL_SPECIAL_OFFERS: string =
    'api/SpecialOffers/Get All Active And Show Offers For Catering';
}

export class BettingAPI {
  static readonly GET_ALL_SPECIAL_OFFERS: string =
    'api/SpecialOffers/Get All Active And Show Offers For Betting';
}

export class AuthenticationAPI {
  static readonly LOGIN: string = 'api/Authentification/Login';
  static readonly REFRESH_TOKEN: string = 'api/Authentification/Refresh';
  static readonly REGISTER: string = 'api/Authentification/Register';
  static readonly RECOVER: string = 'api/Authentification/Recovery';
  static readonly HIDE_EXPIRING_MBC_NOTIFIACTION: string =
    'api/Authentification/Hide Expiring MBC Notification';
}

export class WalletAPI {
  static readonly GET_MBC_BALANCE: string = 'api/Wallet/Balance';
}

export class PurchaseAPI {
  static readonly CATERING_PURCHASE: string = 'api/Purchase/Catering Purchase';
  static readonly BETTING_PURCHASE: string = 'api/TicketScan/Scan Ticket';
}

export class DescriptionsAPI {
  static readonly GET_GAME_RULES: string = 'api/Authentification/GetGameRules';
}

export class PromotionsAPI {
  static readonly GET_ALL_PROMOTIONS: string = 'api/Promotions/Get All Active And Show Promotions';
}

export class SettingsAPI {
  static readonly GET_ALL_ACTIVE_SETTINGS: string = 'api/BannersLoyalty/Get All Active Banners';
}

export class TransactionsAPI {
  static readonly GET_ALL_TRANSACTIONS_FOR_CATERING: string =
    'api/TransactionHistory/Get All Catering Transactions For User';
  static readonly GET_ALL_TRANSACTIONS_FOR_BETTING: string =
    'api/TransactionHistory/Get All Betting Tickets For User';
  static readonly GET_TRANSACTIONS_FOR_ALL_EXPIRING_MBC: string =
    'api/TransactionHistory/Get All Expired Mbc For User';
}

export class VouchersAPI {
  static readonly GET_ALL_VOUCHERS: string = 'api/VouchersLoyalty/Get Vouchers';
  static readonly GET_ALL_PURCHASED_VOUCHERS: string =
    'api/VouchersLoyalty/Get Purchased Vouchers For User';
  static readonly GET_ALL_PRODUCT_VOUCHERS: string = 'api/VouchersLoyalty/Get Product Vouchers';
  static readonly GET_VOUCHER_DETAILS: string = 'api/VouchersLoyalty/Get Voucher Details ';
  static readonly GET_PURCHASED_VOUCHER_DETAILS: string =
    'api/VouchersLoyalty/Get Purchased Voucher Details ';
  static readonly ACTIVATE_PURCHASED_VOUCHER: string =
    'api/VouchersLoyalty/Activate Purchased Voucher ';
  static readonly BUY_VOUCHER: string = 'api/VouchersLoyalty/Add Purchased Voucher';
}

export class BettingTasksAPI {
  static readonly GET_ALL_BETTING_TASKS: string = 'api/BettingTasksLoyalty/Get All Tasks ';
}

export class NotificationCenterAPI {
  static readonly GET_ALL_NOTIFICATIONS_FOR_CLIENT: string =
    'api/NotificationCenter/Get All Notifications For Client';

  static readonly MARK_NOTIFICATION_AS_READ: string =
    'api/NotificationCenter/Mark Notification As Read';

  static readonly MARK_ALL_NOTIFICATIONS_AS_READ: string =
    'api/NotificationCenter/Mark All Notifications As Read';
}
